export const getChannelFromVideoUrl = (url) => {
  if (~url.indexOf('vimeo')) {
    return 'vimeo'
  } else if (~url.indexOf('youtu')) {
    return 'youtube'
  } else {
    return
  }
}
